
import Cookies from "js-cookie";
export class CookieDataManager {
    public static testIsStoreUsable(): boolean {

        const mod = 'local-storage-test';
        try {
            Cookies.set(mod, mod, {expires: 1});
            Cookies.remove(mod);
            return true;
        } catch (e) {
            return false;
        }
    }

    public static save<T>(key: string, dataT?: T, ttlInMinutes: number = 30) {
        const dataString = JSON.stringify(dataT);
        const ttlObjc = new Date(new Date().getTime() + ttlInMinutes * 60 * 1000);
        Cookies.set(key, dataString, {expires: ttlObjc});
    }

    public static load<T>(key: string): T | undefined  {
        if (key === null || key === undefined) return undefined;
        const dataString = Cookies.get(key);
        if (dataString) {
            const dataObj: T = JSON.parse(dataString);
            return dataObj;
        }
        return undefined;
    }
}

